import styled from "styled-components";

export const GeneralStyle = styled.div`
  padding: 0rem;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  h1 {
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
  }
`;
